import React, { useState } from 'react';
import { FileText } from 'lucide-react';
import RFQModal from './RFQModal';
import './RFQForm.scss';

const RFQButton = ({ product, cartItems, quantity = 1, variant = 'secondary' }) => {
    const [isModalOpen, setIsModalOpen] = useState(false);

    // Determine items for the quote
    const getQuoteItems = () => {
        if (cartItems && cartItems.length > 0) {
            return cartItems.map(item => ({
                ...item,
                quantity: item.quantity
            }));
        }
        if (product) {
            return [{
                ...product,
                quantity
            }];
        }
        return [];
    };

    const quoteItems = getQuoteItems();
    const itemCount = quoteItems.length;
    const buttonClass = variant === 'primary'
        ? 'jk-btn jk-btn--primary jk-rfq-btn'
        : 'jk-btn jk-btn--secondary jk-rfq-btn';

    return (
        <>
            <button
                className={buttonClass}
                onClick={() => setIsModalOpen(true)}
                disabled={quoteItems.length === 0}
            >
                <FileText size={18} />
                {cartItems ? (
                    `Request Quote (${itemCount} ${itemCount === 1 ? 'item' : 'items'})`
                ) : (
                    'Request Quote'
                )}
            </button>

            <RFQModal
                isOpen={isModalOpen}
                onClose={() => setIsModalOpen(false)}
                items={quoteItems}
            />
        </>
    );
};

export default RFQButton;
